export default __webpack_public_path__ + "static/media/apex-fintech-solutions.107efa83.png";